import { Component, OnInit } from '@angular/core';
import { LocalStorage, LocalStorageTypes } from '@freelancer/local-storage';

@Component({
  selector: 'webapp-compat-local-storage',
  template: `
    <ng-container></ng-container>
  `,
})
export class CompatLocalStorageComponent implements OnInit {
  constructor(private localStorage: LocalStorage) {}

  ngOnInit() {
    const w = window as any;
    w.webappCompatLocalStorage = {
      get: <T extends keyof LocalStorageTypes>(key: T) =>
        this.localStorage.get(key),
      set: <T extends keyof LocalStorageTypes>(
        key: T,
        item: LocalStorageTypes[T],
      ) => this.localStorage.set(key, item),
    };

    if (w.webappCompatLocalStorageReadyCallback) {
      w.webappCompatLocalStorageReadyCallback();
    }
  }
}
